import styled from "styled-components";

export const Styles = styled.div<{ isMobileOrTablet?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 40px;
  font-size: 24px;
  font-weight: bold;
  border: 1px solid #1e3666;
  border-radius: 4px;
  color: #1e3666;
  margin-bottom: 24px;

  ${({ isMobileOrTablet }) =>
    isMobileOrTablet &&
    `
      background: var(--bg-item);
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      min-height: 26px;
      padding: 4px 8px;
      gap: 10px;
      border-radius: 8px;
    `}
`;
